import request from '@/utils/request'
// 
export function getBlacklist(data) {
    return request({
      url: "/product/goods/blacklist/selectAll",
      method: "get",
      params: data,
    });
  }
export function goodesBlackAdd(data) {
    return request({
      url: '/product/goods/blacklist/add',
      method: 'post',
      data
    })
  }

  export function goodesBlackUpdate(data) {
    return request({
      url: '/product/goods/blacklist/update',
      method: 'post',
      data
    })
  }

  
  export function goodesBlackDelete(data) {
    return request({
      url: '/product/goods/blacklist/deleteOne',
      method: 'post',
      data
    })
  }
